import React, { useMemo } from 'react';
import Accordion from "../../components/accordion";
import { BtnComponent } from '../../components/button';
import { PageDialogContent, PageDialogFooter } from '../../components/dialog';
import { useGroupChatContext } from '../../context/groupchatContext';
import { useGetPatientInfoQuery } from '../../services/chatService';
import PatientAllergy from './allergy';
import PatientMedication from './medication';


const MedicationAllergy = React.memo(({closeMedsAllergyPopup}) => {

    const groupChatContext = useGroupChatContext();
    const {selectedChat} = useMemo(() => ({
        selectedChat: groupChatContext.selectedChat
    }));

    const {data} = useGetPatientInfoQuery({pid: selectedChat.pid});


    return(
        <>
            <PageDialogContent
            contentCls="pt-2 pt-2 px-2 min-h-[70vh] max-h-[70vh] overflow-y-auto overflow-x-auto w-[360px] md:w-auto"
            hideOverFlow={true}
            contentScroll={false}>
                <div className='flex flex-col space-y-2'>
                    <PatientMedication medications={data?.medications} />
                    <PatientAllergy allergies={data?.allergies} />
                </div>
            </PageDialogContent>
            <PageDialogFooter>
                <BtnComponent text="Close" btnType="default" onClick={closeMedsAllergyPopup} />
            </PageDialogFooter>
        </>
    )
})

export default MedicationAllergy;